import { ActionIcon, Code, CopyButton, Group, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import type { FC } from "react";
import { useIntl } from "react-intl";

interface CopyCodeProps {
  text: string;
}

export const CopyCode: FC<CopyCodeProps> = ({ text }) => {
  const intl = useIntl();

  const copyLabel = intl.formatMessage({
    id: "label.copy",
    defaultMessage: "Copy",
  });

  const copiedLabel = intl.formatMessage({
    id: "label.copied",
    defaultMessage: "Copied",
  });

  return (
    <Group gap="0px">
      <Code
        block
        w="calc(100% - 28px)"
        style={{
          whiteSpace: "pre",
          overflow: "hidden",
        }}

      >
        {text}
      </Code>
      <CopyButton value={text} timeout={2000}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? copiedLabel : copyLabel} withArrow position="right">
            <ActionIcon c={copied ? "teal" : "gray"} variant="subtle" onClick={copy}>
              {copied
                ? (
                    <IconCheck size="1rem" />
                  )
                : (
                    <IconCopy size="1rem" />
                  )}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Group>
  );
};
